// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-7c93471c]{font-size:17px;color:#436f98;font-weight:700}.toastui-editor-toolbar-icons.code[data-v-7c93471c]{display:none!important}", ""]);
// Exports
module.exports = exports;
